import React from 'react'

export default function(props) {
  const { result } = props
  const textClass = result.image ? 'text' : 'text-only'
  const resultTitle = result.title
  
  return (
    <>
      {result.image && (
        <div className="image">
          <img src={result.image}/>
        </div>
      )}
      <div className={textClass}>
        <h3 className="result-title">{resultTitle}</h3>
        <div dangerouslySetInnerHTML={{__html: result.text}} />
      </div>
    </>
  )
}